import { FC } from 'react';

import ListIcon from '@mui/icons-material/List';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const TermsCard: FC = () => (
  <ToolCard
    icon={<ListIcon fontSize="large" />}
    title="Įskaičiuota į kainą"
    description="Sąlygos įskaičiuotos/neįskaičiuotos į kelionės kainą"
    action={
      <Button href="terms" startIcon={<ListIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default TermsCard;
